import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { FRONTEND_APP, FrontendApp } from '../providers/frontend-app.token';
import { AuthService } from '../services/auth.service';
import { redirectToLoginApp } from '../utils/cross-app-nav';
import { validatedTeamItemReturnUrl } from '../utils/team-item-return';

export const authGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const app = inject(FRONTEND_APP);
  const router = inject(Router);

  return authService.getAuthenticated().pipe(
    map((authenticated) => {
      if (!authenticated) {
        const returnUrl = app === FrontendApp.MAIN ? validatedTeamItemReturnUrl(_state.url) : undefined;
        return redirectToLoginApp(app, router, returnUrl ? '/login?returnUrl=' + encodeURIComponent(returnUrl) : '/login');
      }

      if (authenticated.recoveryEmailVerified === false) {
        return redirectToLoginApp(app, router, '/verify-email');
      }
      return true;
    }),
  );
};
